import cn from 'classnames';
import React from 'react';
import FadingContainer from 'components/FadingContainer';
import { GridProps } from 'components/Grid';
import {
  ThreeByOneWidgetGrid,
  ThreeByOneUnitProps,
} from 'components/ThreeByOneWidget';
import { useDisplayUnits } from 'state/displayUnits/context';
import { UnitPlaybackManagerProvider } from 'state/unitPlaybackManager';
import styles from './UnitsContainer.module.scss';

export interface UnitsContainerProps extends Pick<GridProps, 'gutter'> {
  children?: React.ReactElement<Omit<ThreeByOneUnitProps, 'id'>>;
  className?: string;
  isMobile?: boolean;
  gridClassName?: string;
  backgroundColor?: string;
}

const UnitsContainer = ({
  children,
  className,
  isMobile,
  gridClassName,
  backgroundColor = 'white',
  gutter,
}: UnitsContainerProps) => {
  const { displayUnits } = useDisplayUnits();

  const child = React.Children.only(children);

  return (
    <FadingContainer
      axis="x"
      backgroundColor={backgroundColor}
      className={className}
    >
      <ThreeByOneWidgetGrid
        className={cn(
          styles.grid,
          { [styles.grid__mobile]: isMobile },
          gridClassName,
        )}
        gutter={gutter}
        orientation="horizontal"
      >
        <UnitPlaybackManagerProvider>
          {displayUnits.map((id) =>
            !React.isValidElement<ThreeByOneUnitProps>(child)
              ? null
              : React.cloneElement(child, {
                  className: cn(
                    styles.unit,
                    { [styles.unit__mobile]: isMobile },
                    child.props.className,
                  ),
                  key: id,
                  id: id,
                }),
          )}
        </UnitPlaybackManagerProvider>
      </ThreeByOneWidgetGrid>
    </FadingContainer>
  );
};

export default UnitsContainer;
